/* esm.sh - @lit/reactive-element@1.6.3/decorators/query-all */
import{decorateProperty as t}from"./base.mjs";function u(o){return t({descriptor:l=>({get(){var r,e;return(e=(r=this.renderRoot)===null||r===void 0?void 0:r.querySelectorAll(o))!==null&&e!==void 0?e:[]},enumerable:!0,configurable:!0})})}export{u as queryAll};
/*! Bundled license information:

@lit/reactive-element/decorators/query-all.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
//# sourceMappingURL=query-all.mjs.map